// Update theme-img and slick-list height based on theme-gallery height
// function adjustThemeImgHeight() {
//   const themeGallery = document.querySelector('.theme-gallery');
//   const themeImgs = document.querySelectorAll('.theme-img');
//   const slickLists = document.querySelector('.slick-list');

//   if (window.innerWidth > 768 && themeGallery) {
//     const galleryHeight = themeGallery.offsetHeight;
//     console.log(galleryHeight);
//     // slickLists.style.height = `${galleryHeight}px`;
//     // themeGallery.style.marginTop = `-${galleryHeight}px`;
//   } else {
//     themeImgs.forEach(img => {
//       img.style.height = '';
//     });
//     slickLists.forEach(slick => {
//       slick.style.height = '';
//     });
//     if (themeGallery) {
//       themeGallery.style.marginTop = '';
//     }
//   }
// }

// Run on load
// window.addEventListener('load', () => {
//   setTimeout(adjustThemeImgHeight, 500);
// });


// Run on resize
// window.addEventListener('resize', adjustThemeImgHeight);

// window.addEventListener('load', () => {
//   setTimeout(() => {
//     const productMediaImg = document.querySelector('.theme-images .product-media img');
//     const slickList = document.querySelector('.slick-slider .slick-list');
//     const themeGallery = document.querySelector('.theme-gallery');

//     if (productMediaImg && slickList && themeGallery) {
//       const imgHeight = productMediaImg.clientHeight;

//       if (imgHeight > 0) {
//         slickList.style.height = imgHeight + 'px';
//         themeGallery.style.marginTop = `-${imgHeight}px`;
//         console.log("tsest")
//       }
//     }
//   }, 200);
// });


// function continuousHeightCheck() {
//   const productMediaImg = document.querySelector('.theme-images img');
//   const slickList = document.querySelector('.slick-list');
//   const themeGallery = document.querySelector('.theme-gallery');
  
//   if (productMediaImg && slickList && themeGallery) {
//     // Use naturalHeight if clientHeight is 0 (image might be hidden)
//     let imgHeight = productMediaImg.clientHeight;
//     if (imgHeight === 0 && productMediaImg.naturalHeight > 0) {
//       imgHeight = productMediaImg.naturalHeight;
//     }
    
//     if (imgHeight > 0) {
//       const currentSlickHeight = slickList.style.height;
//       const currentMarginTop = themeGallery.style.marginTop;
//       const expectedHeight = imgHeight + 'px';
//       const expectedMarginTop = `-${imgHeight+6}px`;
      
//       // Check if adjustment is needed
//       if (currentSlickHeight !== expectedHeight || currentMarginTop !== expectedMarginTop) {
//         slickList.style.height = expectedHeight;
//         themeGallery.style.marginTop = expectedMarginTop;
//         console.log("Height corrected to: " + imgHeight + "px");
//       }
//     }
//   }
// }

// // Force update function for initial load
// function forceHeightUpdate() {
//   const productMediaImg = document.querySelector('.theme-images .product-media img');
//   const slickList = document.querySelector('.slick-slider .slick-list');
//   const themeGallery = document.querySelector('.theme-gallery');
  
//   if (productMediaImg && slickList && themeGallery) {
//     // Use naturalHeight if clientHeight is 0 (image might be hidden)
//     let imgHeight = productMediaImg.clientHeight;
//     if (imgHeight === 0 && productMediaImg.naturalHeight > 0) {
//       imgHeight = productMediaImg.naturalHeight;
//     }
    
//     if (imgHeight > 0) {
//       // Force update regardless of current values
//       slickList.style.height = imgHeight + 'px';
//       themeGallery.style.marginTop = `-${imgHeight+6}px`;
//       console.log("Force updated height to: " + imgHeight + "px");
//     }
//   }
// }

// // Start continuous checking when page loads
// window.addEventListener('load', () => {
//   // Force initial update with delay (same as your working code)
//   setTimeout(forceHeightUpdate, 200);
  
//   // Check again with longer delay to ensure it applied
//   setTimeout(forceHeightUpdate, 1000);
  
//   // And one more time with even longer delay
//   setTimeout(forceHeightUpdate, 2000);
  
//   // Then start continuous monitoring
//   setTimeout(() => {
//     setInterval(continuousHeightCheck, 500);
//   }, 3000);
// });

// // Also check on window resize
// window.addEventListener('resize', () => {
//   setTimeout(continuousHeightCheck, 100);
// });






function disableLazyLoadingOnMobile() {
  if (window.innerWidth <= 768) {
    document.querySelectorAll('.theme-img img[data-srcset]').forEach(img => {
      // Set srcset and sizes immediately
      img.setAttribute('srcset', img.getAttribute('data-srcset'));
      img.setAttribute('sizes', img.getAttribute('data-sizes'));

      // Remove lazy loading classes
      img.classList.remove('lazyautosizes', 'lazyloaded', 'fade-in');

      // Optional: force reloading
      const src = img.getAttribute('data-srcset')?.split(' ')[0];
      if (src) {
        img.src = src;
      }
    });
  }
}

window.addEventListener('load', disableLazyLoadingOnMobile);




// update homepage images of featured product
function updateVariantImages() {
  document.querySelectorAll('.var-img.var-show').forEach(img => {
    img.classList.remove('var-show');
  });

  const activeSwatch = document.querySelector('.clickyboxes li a.active');
  if (!activeSwatch) {
    return;
  }

  const value = activeSwatch.dataset.value?.trim();
  if (!value) {
    return;
  }

  const altToMatch = `Colour_${value}`.toLowerCase();
  console.log("🔎 Searching for:", altToMatch);

  const varImgs = document.querySelectorAll('.var-img');
  let matchedCount = 0;

  varImgs.forEach((block, index) => {
    const img = block.querySelector('img');
    const alt = img?.alt?.trim().toLowerCase();

    if (alt === altToMatch) {
      if (matchedCount < 2) {
        block.classList.add('var-show');
        matchedCount++;
      }
    }
  });
}


// Wait for swatches to exist in DOM
function waitForSwatchesAndInit() {
  const swatchesExist = document.querySelector('.clickyboxes li a');
  if (swatchesExist) {
    updateVariantImages();

    // Listen to swatch click
    document.querySelectorAll('.clickyboxes li a').forEach(swatch => {
      swatch.addEventListener('click', e => {
        // Let theme update the .active class first
        requestAnimationFrame(() => {
          setTimeout(updateVariantImages, 50);
        });
      });
    });
  } else {
    // Try again in 100ms
    setTimeout(waitForSwatchesAndInit, 100);
  }
}

// Init on DOM ready
document.addEventListener('DOMContentLoaded', () => {
    waitForSwatchesAndInit();
});



//homepage featured product swatch code
function getActiveSwatchValue() {
  const activeSwatch = document.querySelector('.clickyboxes a.active');
  if (activeSwatch) {
    const value = activeSwatch.getAttribute('data-value');
    console.log("✅ Active swatch on load or change:", value);

    // ✅ Trigger click on .thumb-active after swatch change
    const thumbActive = document.querySelector('.thumb-active');
    if (thumbActive) {
      console.log("🖱️ Clicking .thumb-active due to swatch change");
      thumbActive.click();
    } else {
      console.log("⚠️ .thumb-active not found");
    }

  } else {
    console.log("⚠️ No active swatch found.");
  }
}

function setupSwatchListener() {
  const swatchLinks = document.querySelectorAll('.clickyboxes a');
  if (swatchLinks.length === 0) {
    console.log("No swatches found yet, retrying...");
    setTimeout(setupSwatchListener, 300); // Retry after 300ms
    return;
  }

  console.log(`Found ${swatchLinks.length} swatches.`);

  swatchLinks.forEach(link => {
    link.addEventListener('click', function () {
      setTimeout(() => {
        getActiveSwatchValue();
      }, 10); // Wait for active class to be applied
    });
  });

  // Trigger once on initial load
  getActiveSwatchValue();
}

document.addEventListener('DOMContentLoaded', () => {
  if (window.innerWidth > 768) {
    setupSwatchListener();
  }
});


// mobile version
$(window).on('load', function () {
  const $gallery = $('.product-gallery'); // adjust if needed
  const $mediaBlocks = $gallery.find('.product-media[data-media-id]');

  $mediaBlocks.each(function () {
    const $media = $(this);

    // Show the media via theme's logic
    if (typeof theme !== 'undefined' && typeof theme.productGallery !== 'undefined' && typeof theme.productGallery.showMedia === 'function') {
      theme.productGallery.showMedia($media, false, true); // autoplay = false, preventHide = true
    } else {
      $media.show().addClass('product-media--current');
    }

    // Trigger lazy loading
    $media.find('img[data-src]').each(function () {
      if (typeof lazySizes !== 'undefined' && lazySizes.loader) {
        lazySizes.loader.unveil(this);
      } else {
        this.src = this.getAttribute('data-src');
      }
    });

    if ($media.find('img[data-srcset]').length) {
      $media.find('img[data-srcset]').each(function () {
        this.srcset = this.getAttribute('data-srcset');
      });
    }
  });
});


